import { BarChart, Bar, LineChart, Line, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer, CartesianGrid } from "recharts";

export const AREA = { bunpo: "Bunpo (Tata bahasa)", partikel: "Partikel", kanji: "Kanji", dokkai: "Dokkai (Bacaan)", goi: "Goi (Kosakata)", hyougen: "Hyougen (Ungkapan)", kaigo: "Kaigo", nogyo: "Nogyo" };
export const EV = { tts_play: "Putar audio TTS", offline_save: "Simpan modul offline", offline_study: "Belajar offline", offline_test: "Mini test offline", push_enable: "Aktifkan notifikasi", push_disable: "Matikan notifikasi", pdf_export: "Ekspor PDF" };
export const fmt = (v, suf = "") => (v === null || v === undefined ? "–" : `${v}${suf}`);

export function Section({ title, hint, children, testid }) {
  return (
    <section className="soft-card p-5" data-testid={testid}>
      <div className="flex flex-wrap items-baseline justify-between gap-2">
        <h3 className="font-jpserif text-lg">{title}</h3>
        {hint && <p className="text-xs text-muted-foreground">{hint}</p>}
      </div>
      <div className="mt-4">{children}</div>
    </section>
  );
}

export function Kpi({ label, value, sub, tone = "", testid }) {
  return (
    <div className="rounded-2xl border border-border bg-background/60 p-4" data-testid={testid}>
      <p className="truncate text-[11px] uppercase tracking-wide text-muted-foreground">{label}</p>
      <p className={`mt-1 truncate font-jpserif text-2xl ${tone}`}>{value}</p>
      {sub && <p className="mt-0.5 truncate text-[11px] text-muted-foreground">{sub}</p>}
    </div>
  );
}

export function Tbl({ cols, rows, testid, empty = "Belum ada data dalam periode ini." }) {
  if (!rows.length) return <p className="text-xs text-muted-foreground" data-testid={testid}>{empty}</p>;
  return (
    <div className="overflow-x-auto" data-testid={testid}>
      <table className="w-full text-xs">
        <thead><tr className="text-left text-[11px] uppercase tracking-wide text-muted-foreground">{cols.map((c) => <th key={c} className="px-2 py-1.5 font-medium">{c}</th>)}</tr></thead>
        <tbody>{rows.map((r, i) => <tr key={i} className="border-t border-border/60">{r.map((v, j) => <td key={j} className="px-2 py-1.5 align-top">{v}</td>)}</tr>)}</tbody>
      </table>
    </div>
  );
}

export function TrendChart({ trend }) {
  return (
    <div className="h-64 min-w-0 overflow-hidden" data-testid="insight-trend-chart">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={trend} margin={{ top: 8, right: 12, left: -16, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" />
          <XAxis dataKey="label" tick={{ fontSize: 11 }} /><YAxis tick={{ fontSize: 11 }} allowDecimals={false} />
          <Tooltip labelFormatter={(l, p) => `${l} · ${p?.[0]?.payload?.start} – ${p?.[0]?.payload?.end}`} />
          <Legend wrapperStyle={{ fontSize: 12 }} />
          <Line type="monotone" dataKey="active" name="Siswa aktif" stroke="#b8322a" strokeWidth={2.2} dot={{ r: 3 }} />
          <Line type="monotone" dataKey="modules" name="Modul selesai" stroke="#5b7f5a" strokeWidth={1.8} dot={{ r: 2 }} />
          <Line type="monotone" dataKey="tests" name="Mini test" stroke="#7a6f68" strokeWidth={1.5} dot={{ r: 2 }} />
          <Line type="monotone" dataKey="assessments" name="Assessment" stroke="#c98a2b" strokeWidth={1.5} dot={{ r: 2 }} strokeDasharray="4 3" />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}

export function AreaBars({ areas, onSelect }) {
  const data = areas.map((a) => ({ ...a, label: AREA[a.area] || a.area }));
  if (!data.length) return <p className="text-xs text-muted-foreground">Belum ada jawaban dalam periode ini.</p>;
  const pick = (d) => { const a = d?.payload?.area ?? d?.area; if (a && onSelect) onSelect(a); };
  return (
    <div className="h-56 min-w-0 overflow-hidden" data-testid="insight-area-chart">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} layout="vertical" margin={{ top: 4, right: 24, left: 8, bottom: 0 }} onClick={(s) => pick(s?.activePayload?.[0])}>
          <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" horizontal={false} />
          <XAxis type="number" domain={[0, 100]} tick={{ fontSize: 11 }} unit="%" /><YAxis type="category" dataKey="label" width={120} tick={{ fontSize: 11, cursor: "pointer" }} onClick={(e) => { const a = data.find((x) => x.label === e?.value); if (a) pick(a); }} />
          <Tooltip formatter={(v, n, p) => [`${v}% (${p.payload.wrong}/${p.payload.total}) · klik untuk buka soal`, "Tingkat salah"]} cursor={{ fill: "hsl(var(--muted))" }} />
          <Bar dataKey="error_pct" name="% salah" fill="#b8322a" radius={[0, 6, 6, 0]} cursor="pointer" onClick={pick} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
